export default __webpack_public_path__ + "static/media/fisetiLogo.135bc87c.svg";